import React from "react";
import { useDispatch, useSelector } from "react-redux";
import classes from './SummativeAssessmentEdit.module.css';
import { onKeyDown } from "../../../../../../service.js";
import { submissionsApi } from "../../../../../../utils";
import NumericScore from "../../NumericScore/NumericScore";
import VerbalScore from "../../VerbalScore/VerbalScore";
import { throwApiError } from "../../../../../lms-shared/store/error-handling-actions";
import SuccessProjectPopup from "../../../../../lms-shared/UI/Popups/SuccessProjectPopup/SuccessProjectPopup";
import RemarkEditor from "../RemarkEditor/RemarkEditor";
import { ScoreTypeEnum } from "../../../../../../models/ScoreTypeEnum"

const SummativeAssessmentEdit = ({
    submissionData,
    setSubmissionData,
    setRemarks,
    setScoreType,
    feedback,
    changeSelectedAppreciationTextOption,
    setMessage,
    setEditData,
    markAssessmentAsChecked,
    scoreAdditionalData,
    changeScoreType,
    changeCriteriaScoreForNumeric,
    changeFeedbackCriterionDisable,
    handleNotification }) => {

    const dispatch = useDispatch();

    const { texts, lang } = useSelector(state => state.translate);

    const totalScore = Math.round((calculateWeightedScore(feedback?.feedbackCriteria)) * 100) / 100
    const weight = feedback?.feedbackCriteria.filter(f => !f.disable)?.reduce((acc, o) => acc + (o.weight), 0)
    function calculateWeightedScore(submissionData) {
        const score = submissionData?.filter(item => !item.disable).reduce((totelScore, item) => {
            if (!item.disable) {
                const weightedScore = (item.criteriaScoreForNumeric * (item.weight)) / 100;
                return totelScore + weightedScore;
            }
            return totelScore;
        }, 0);
        return score;
    }


    const send = () => {
        if (feedback.feedbackCriteria.filter(s => s.criteriaScoreForNumeric != null).length != feedback.feedbackCriteria.filter(s => !s.disable).length) {
            setMessage(<SuccessProjectPopup minHeight={"168px"} myHeight={"168px"} myWidth={'367px'} close={() => setMessage(null)} color="#CCF0F0" title={texts.Warn} type="Warn">
                <div className={classes.AlertContent}>{texts.errorNotFullFeedback}</div>
                <button className={classes.AlertBtn} onClick={() => setMessage(null)}>{texts.ok}</button>
            </SuccessProjectPopup>)
            return
        }

        let dynamicScore = {
            ScoreType: feedback.scoreType === ScoreTypeEnum.textScore ? 'textScore' : 'numScore',
        }
        feedback.feedbackCriteria.forEach(x => {
            dynamicScore[x.criteria[lang]] = feedback.scoreType === ScoreTypeEnum.textScore ? x.selectedAppreciationTextOption : x.criteriaScoreForNumeric
        })
        dynamicScore.weightedScore = totalScore;
        const submissionFeedbackInput = {
            id: submissionData.id,
            score: Number(dynamicScore.weightedScore),
            scoreAdditionalData: JSON.stringify(dynamicScore),
            remarks: feedback.remarks,
        }
        submissionsApi.submissionsScorePost({ submissionFeedbackInput }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.submissionFeedbackSendError, error: error, statusCode: response?.statusCode, message: "callBackFunc " + error.message, level: 2, component: "SummativeAssessmentEdit", line: 77 }))
            }
            else {
                setSubmissionData({ ...submissionData, ...submissionFeedbackInput, submissionStatusId: resdata })
                setEditData(false)
                markAssessmentAsChecked(submissionData.id);
                let textHe = "", textAr = "", textEn = "";
                textHe = `${texts.submissionsScoredMessageHe}${submissionData?.assessmentName}`;
                textAr = `${texts.submissionsScoredMessageAr}${submissionData?.assessmentName}`;
                textEn = `${texts.submissionsScoredMessageEn}${submissionData?.assessmentName}`;
                if (feedback.scoreType === ScoreTypeEnum.numScore) {
                    const weightedScore = calculateWeightedScore(feedback.feedbackCriteria);
                    textHe = `${textHe}: ${weightedScore}`;
                    textAr = `${textAr}: ${weightedScore}`;
                    textEn = `${textEn}: ${weightedScore}`;
                }
                handleNotification(textHe, textAr, textEn)
            }
        })
    }

    return (
        <div>
            <RemarkEditor setRemarks={setRemarks} remarks={feedback.remarks} isGroup={submissionData.submittedByUser.isGroup} />
            <>
                <div className={classes.SubTitleContainer}>
                    <div>{texts.indicator}</div>
                    <div className={classes.ToggleBtn}>
                        <div className={feedback.scoreType === ScoreTypeEnum.textScore ? classes.ActiveBtn : classes.DefaultBtn} onClick={() => changeScoreType(ScoreTypeEnum.textScore)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeScoreType(ScoreTypeEnum.textScore))}>{texts.verbalAssessment}</div>
                        <div className={feedback.scoreType === ScoreTypeEnum.numScore ? classes.ActiveBtn : classes.DefaultBtn} onClick={() => changeScoreType(ScoreTypeEnum.numScore)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => changeScoreType(setScoreType, ScoreTypeEnum.numScore))}>{texts.numScore}</div>
                    </div>
                </div>
                {feedback.scoreType === ScoreTypeEnum.textScore ?
                    <VerbalScore changeSelectedAppreciationTextOption={changeSelectedAppreciationTextOption}
                        feedback={feedback}
                        scoreAdditionalData={scoreAdditionalData}
                        changeFeedbackCriterionDisable={changeFeedbackCriterionDisable}
                        weight={weight}
                        totalScore={totalScore}
                    />
                    :
                    <NumericScore feedback={feedback}
                        changeFeedbackCriterionDisable={changeFeedbackCriterionDisable}
                        changeCriteriaScoreForNumeric={changeCriteriaScoreForNumeric}
                        weight={weight}
                        totalScore={totalScore}
                    />
                }
                <button className={classes.SubmitBtn}
                    onClick={send}
                    tabIndex="0" role="button"
                    onKeyDown={e => onKeyDown(e, send)}
                >{texts.send}</button>
            </>
        </div>
    )
}
export default SummativeAssessmentEdit;